export const chartTheme = {
  grid: '#475569',
  tick: { fill: '#94a3b8', fontSize: 10 },
  tooltip: {
    contentStyle: {
      background: '#0f172a',
      border: '1px solid #334155',
      borderRadius: 6,
      color: '#f1f5f9',
      fontSize: 11,
    },
    labelStyle: { color: '#cbd5e1', fontWeight: 600 },
    itemStyle: { color: '#f1f5f9' },
  },
  legend: {
    wrapperStyle: { fontSize: 10, color: '#94a3b8', paddingTop: 2 },
  },
};
